import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Icon } from "@/components/Icon";
import { COMPANY } from "@/lib/content";

const linkCls =
  "text-[14px] text-white/60 hover:text-white transition-colors duration-200";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#191C54] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-4">
            <Logo light />
            <p className="mt-6 text-[14px] leading-[1.75] text-white/60 max-w-xs">
              Accounting, bookkeeping, payroll and consultancy services for
              businesses across Aruba. Serving with trust and personal care
              since {COMPANY.since}.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-[12px] uppercase tracking-[0.16em] text-white/40">
              Company
            </h4>
            <ul className="mt-5 space-y-3.5">
              <li><Link to="/" className={linkCls} data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/about" className={linkCls} data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/services" className={linkCls} data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/contact" className={linkCls} data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-[12px] uppercase tracking-[0.16em] text-white/40">
              Services
            </h4>
            <ul className="mt-5 space-y-3.5">
              <li><Link to="/services" className={linkCls}>Bookkeeping</Link></li>
              <li><Link to="/services" className={linkCls}>Payroll</Link></li>
              <li><Link to="/services" className={linkCls}>Consultancy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-[12px] uppercase tracking-[0.16em] text-white/40">
              Get in Touch
            </h4>
            <ul className="mt-5 space-y-4">
              <li className="flex items-start gap-3.5">
                <Icon name="Phone" className="h-5 w-5 text-[#9AA6D8] mt-0.5 shrink-0" strokeWidth={1.6} />
                <a href={COMPANY.phoneHref} className="text-[14px] text-white/75 hover:text-white transition-colors duration-200" data-testid="footer-phone">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3.5">
                <Icon name="Mail" className="h-5 w-5 text-[#9AA6D8] mt-0.5 shrink-0" strokeWidth={1.6} />
                <a href={COMPANY.emailHref} className="text-[14px] text-white/75 hover:text-white transition-colors duration-200" data-testid="footer-email">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-3.5">
                <Icon name="MapPin" className="h-5 w-5 text-[#9AA6D8] mt-0.5 shrink-0" strokeWidth={1.6} />
                <a href={COMPANY.mapLink} target="_blank" rel="noopener noreferrer" className="text-[14px] text-white/75 hover:text-white transition-colors duration-200" data-testid="footer-address">{COMPANY.addressLine1}, {COMPANY.addressLine2}</a>
              </li>
            </ul>

            <div className="mt-6 flex items-center gap-3" data-testid="footer-social">
              <a href={COMPANY.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-white hover:border-white/40 hover:bg-white/5 transition-colors duration-200">
                <Icon name="Facebook" className="h-4 w-4" strokeWidth={1.8} />
              </a>
              <a href={COMPANY.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-white hover:border-white/40 hover:bg-white/5 transition-colors duration-200">
                <Icon name="Instagram" className="h-4 w-4" strokeWidth={1.8} />
              </a>
              <a href={COMPANY.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="social-linkedin" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-white hover:border-white/40 hover:bg-white/5 transition-colors duration-200">
                <Icon name="Linkedin" className="h-4 w-4" strokeWidth={1.8} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-white/50 text-center sm:text-left">
            © {year} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-[13px] text-white/50">Serving Aruba since {COMPANY.since}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
